import { END } from "redux-saga";
import dynamic from "next/dynamic";
import { NextSeo } from "next-seo";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import {
    getPortalFaqs,
    getPortalSection,
    getPortalSettings,
    getSeoData,
} from "@/store/actions";
import { wrapper } from "@/store/index";
import { useEffect } from "react";

const HelpCenter = dynamic(
    () => import("@/components/help-center/mainPage/Index"),
    {
        ssr: false,
    }
);
const BreadCrumb = dynamic(
    () => import("@/components/breadCrumbs/breadCrumb-1/Index"),
    {
        ssr: false,
    }
);
const HelpCenterPage = () => {
    const { locale } = useIntl();
    const { seoData } = useSelector((state) => state.portalSettings);
    // const dispatch = useDispatch();

    // ========== SEO Data ==========
    const seoDataForPage = seoData?.content?.items?.find(
        (item) => item?.pageName === "helpCenter"
    );

    // useEffect(() => {
    //     dispatch(getPortalSection({ cookies: {} }));
    // }, [dispatch]);

    return (
        <>
            <NextSeo
                title={`${seoDataForPage?.title?.[locale]}`}
                additionalMetaTags={[
                    {
                        name: "keywords",
                        content: seoDataForPage?.keywords?.[locale],
                    },
                    {
                        name: "description",
                        content: seoDataForPage?.description?.[locale],
                    },
                ]}
            />
            <BreadCrumb type="help-center" />
            <HelpCenter />
        </>
    );
};

export const getStaticProps = wrapper.getStaticProps((store) => {
    return async () => {
        store.dispatch(getPortalSection({ cookies: {} }));
        store.dispatch(getSeoData({ cookies: {} }));
        store.dispatch(getPortalSettings({ cookies: {} }));
        store.dispatch(getPortalFaqs({ cookies: {} }));
        store.dispatch(END);
        await store.sagaTask.toPromise();

        return { props: {}, revalidate: 1 };
    };
});

export default HelpCenterPage;
